import * as Yup from 'yup';
import { isAllOptionSelected } from '../utils/yearsRangeOptions';

export default () =>
  Yup.object().shape({
    allRangeOfYears: Yup.boolean(),
    yearMinValue: Yup.object()
      .nullable()
      .when('allRangeOfYears', {
        is: (value) => !isAllOptionSelected(value),
        then: (schema) =>
          schema.shape({
            value: Yup.string().required('Field is required'),
            label: Yup.string(),
          }),
        otherwise: (schema) =>
          schema
            .shape({
              value: Yup.string().nullable(),
              label: Yup.string().nullable(),
            })
            .nullable(),
      }),

    yearMaxValue: Yup.object()
      .nullable()
      .when('allRangeOfYears', {
        is: (value) => !isAllOptionSelected(value),
        then: (schema) =>
          schema.shape({
            value: Yup.string().required('Field is required'),
            label: Yup.string(),
          }),
        otherwise: (schema) =>
          schema
            .shape({
              value: Yup.string().nullable(),
              label: Yup.string().nullable(),
            })
            .nullable(),
      }),
  });
